import { Component, OnInit, Input, TemplateRef, ViewChild, ViewChildren, ChangeDetectorRef, Output, EventEmitter, ElementRef, OnDestroy } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { IImageList, IPropertyDetails, MetaTagData } from '../shared/models/propertydetails';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { IPropertyCard } from '../shared/models/propertycard';
import { HomeService } from '../shared/providers/home.service'; //Remove all the code related to home service once similar properties is received
import { IPropertySearchCriteria } from '../shared/models/propertysearchcriteria';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { AuthService } from '../shared/auth/auth.service';
import { IPlaceOfferInputModel } from '../shared/models/PlaceOfferInputModel';
declare module 'googlemaps';
//import Player from '@vimeo/player';
import { ToastService } from '../shared/providers/toast.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { CommonService } from '../shared/providers/common.service';
import { LoaderService } from '../shared/providers/loader.service';
import { IDocumentAccessInputModel } from '../shared/models/DocumentAccessInputModel';
import { IDocumentAccessOutputModel } from '../shared/models/DocumentAccessOutputModel';
import { Lightbox } from 'ngx-lightbox';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { environment } from '../../environments/environment'
import { DataTablesResponse } from '../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { OpportunityOfferOutputModel } from '../shared/models/OpportunityOfferOutputModel'
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { ContactType, DocumentType, DocAccessStatus } from '../shared/enum/enum';
import { SavePropertyAccessLogModel } from '../shared/models/SavePropertyAccessLogModel';
import { IMessageInput } from '../shared/models/MessageInputModel';
import { ValidationService } from '../shared/providers/validation.service';
import { IAddToFavorites } from '../shared/models/AddToFavoriteInputModel';
import { BrokerageManagerService } from '../shared/providers/brokerage-manager.service';
import { collapseColumns } from '../shared/models/collapseColumns';
import { ComparePropertiesModel } from '../shared/models/ComparePropertiesModel';
import { ComparisonService } from '../shared/providers/comparison.service';
import { FileUploadService } from '../shared/providers/fileupload.service';
import { IFileUpload } from '../shared/models/fileupload';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { SharedService } from '../shared/providers/shared.service';
import { Trade1031Service } from '../shared/providers/Trade1031.service';
import { IPropertyChatModel } from '../shared/models/PropertyChatModel';
import { OfferComponent } from '../property-listing/place-offer/offer.component';
import { MultipleEmailIdModel } from '../shared/models/MultipleEmailIdModel';
import { IShareReportModel } from '../shared/models/IShareRportModel';
import { IUpdateTimestampModel } from '../shared/models/IUpdateTimestampModel';
import { BrowserService } from '../shared/browser-service.service';
import { Tabs } from '../1031-exchange/1031-dashboard/1031-dashboard.component';
import { Subscription } from 'rxjs';
import { DocumentOutputModel } from '../shared/models/SavePropertyInputModel';
import { ISharedProperty } from '../shared/models/SharedPropertyInputModel';


export enum PropertyTabs {
  Dashboard = 0,
  Home = 1,
  Memorandom = 2,
  Diligence = 3,
  Offer = 4,
  Inquiries = 5,
  PlaceOffer = 6,
  OfferDetail = 7,
  SendInquiryPopup = 8,
  Message = 9,
  Share = 10,
  ActivityLog = 11,
  Brokerage = 12,
  Duplicates = 13,
  More = 14,
  Analytics = 15,
  Comps = 16,
  OfferAnalytics = 17,
  FinancialSummary = 18,
  Notifications = 19,
}

export enum DashboardTabs {
  Dashboard = 1,
  Prospects = 2,
  Files = 3,
  DealContacts = 4,
  People = 5,
  DocAccess = 6
}

enum SocialMedia {
  Twitter = 1,
  FB = 2,
  LinkedIn = 3
}

export class ICategory {
  id: number;
  name: string
}


@Component({
  selector: 'be-property-view',
  templateUrl: './property-view.component.html'
})

export class ViewPropertyComponent implements OnInit, OnDestroy {

  modalRef: BsModalRef;
  modalRefVerify: BsModalRef;
  modalUserRef: BsModalRef;
  property = {} as IPropertyDetails;
  toggleDetailsText = '- Hide Details';
  isDescriptionVisible = true;
  propertyGuid: string = "";
  userGuid: string = "0000";
  sharedOmProperties: number[] = [];
  propertyTabs = PropertyTabs;
  public accessAdded: number = 0;
  activeTab = this.propertyTabs.Home;
  similarProperties: IPropertyCard[] = [];
  Images: IImageList[] = [];
  similarPropertiesCount: number;
  searchCriteria = {} as IPropertySearchCriteria;
  IsAgreementRequired: boolean = false;
  isUserLoggedIn = false;
  placeOfferInputModel = {} as IPlaceOfferInputModel;
  savePropertyAccessLogModel = {} as SavePropertyAccessLogModel;
  fileExtensionType = "document";
  fileUploadType: string = "single";
  currentsharedurl: string;
  currentsharedtext: string;
  currentDetailsPage: string = "propertyDetails";
  showFileUpload = true;
  activeBannerTab = 1;
  haveaccesstoviewlocation: boolean = true;
  sourceTab: string;
  map: google.maps.Map;
  //@ViewChildren('offComponent') offComponentElement: OfferComponent;
  @ViewChild('gmap') gmapElement: any;
  @ViewChild('gmapSatellite') gmapSatelliteElement: any;
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
  propertyLatitude: number = 0;
  OMUserCount: number = 0;
  propertyLongitude: number = 0;
  portfolioProperties: any[] = [];
  contactType = ContactType;
  hasOtherContactType = false;
  user: any;
  utm_id: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_term: string;
  utm_content: string;
  shared_token: string;
  Token: string;
  disableBtn: boolean = false;
  loggedInUserId: number = 0;
  canEditProperty = false;
  canEditPropertyForBroker = false;
  videoUrl: SafeResourceUrl = null;
  videoUrlResponse: any;
  dueDiligenceDocList: any[] = [];
  ddDocumentList: any[] = [];
  categoryLst = [];
  selectedCategories: number[] = []
  dddocumentlst: DataTablesResponse[];
  offeringMemorandomDocList: any[] = [];
  docAccessInput = {} as IDocumentAccessInputModel;
  docAccessOutput = {} as IDocumentAccessOutputModel;
  docAccessStatus = DocAccessStatus;
  defaultProfilePic: string;
  ndaDetails = {} as any;
  only1PropImage = false;
  propertyId: number;
  dtOptions = {};
  dddtOptions = {};
  table: DataTableDirective;
  offers: OpportunityOfferOutputModel[];
  selectedOfferId: number;
  currentIndex: number;
  isPropertyForSale = true;
  visewDocRequestList: boolean = false;
  @ViewChild(DataTableDirective, { static: true }) dtElement: DataTableDirective;
  @Output() onMessageClick = new EventEmitter();
  prevPage = "Property List";
  prevPageRouteLink = "propertylisting";
  public source: string = 'OM';
  placeOfferVisibility: boolean = false;
  messageInput = {} as IMessageInput;
  unreadMessageCount: number = 0;
  showContactUs: boolean = true;
  currentUrl: string;
  socialMedia = SocialMedia;
  enableShare: boolean = true;
  viewActivityLog: boolean = false;
  isContactPerson: boolean = false;
  viewBrokerage: boolean = false;
  enableMessage: boolean = false;

  showNodataOM: boolean = false;
  showNodataDD: boolean = false;
  IsEditClick: boolean = false;
  canEditHistory: boolean = false;
  TableColumns = [];
  DDColumns = [];
  comparePropertiesModel = {} as ComparePropertiesModel;
  isFav = false;
  isDisliked = false;
  sourceToken: string;
  tickerSymbol = "DIS";
  inputFileUpload = {} as IFileUpload;
  filesCollection = [];
  caDocId = 0;
  propertyGuidSlug: string;
  previousTab: string;
  prevRoute = "";
  file: File;
  propertyChatModel = {} as IPropertyChatModel;
  @Input() showplaceOffer: boolean;
  fromOfferMatrix: boolean = false;
  showmap = true;
  capratetext: string = 'Cap Rate';
  characterstics: string = '';
  protected readonly BASE_URL: string = environment.base_url;
  protected readonly Site_URL: string = environment.siteurl;
  documentPreview: BsModalRef;
  docPreview: any;
  authSubscription: Subscription = new Subscription();
  viewNotifications = false;
  //defaultStatusTextCategory: IMultiSelectTexts = {
  //  defaultTitle: 'Filter By Cagtegory',
  //};
  defaultTypeSettingsCategory = {
    dynamicTitleMaxItems: 1,
  };

  categoryids = [];

  constructor(private _brokerageManagerService: BrokerageManagerService,
    private _propertyService: PropertyListingService, private _lightbox: Lightbox,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private _homeService: HomeService, private browserService: BrowserService,
    private modalService: BsModalService,
    public authService: AuthenticationService, private _toastService: ToastService, private _propertyManagerService: PropertyManagementService, private sanitizer: DomSanitizer, public commonService: CommonService, private loaderService: LoaderService,
    private metaTag: Meta, public Validation: ValidationService, private _auth0: AuthService, private cdRef: ChangeDetectorRef, private _comparisonService: ComparisonService,
    private _fileUploadService: FileUploadService, private Shared: SharedService, private trade1031Service: Trade1031Service, private title: Title) {
    setTimeout(() => {
      const id = this.activatedRoute.snapshot.params.id || '';
      this.propertyGuidSlug = id;
      this.generateMetaTags();
    }, 1000);
    pdfMake.vfs = pdfFonts?.pdfMake?.vfs;
  }
  saveOfferingMemorandomToAuditLog(DocumentId: number) {

    if (this.isUserLoggedIn) {
      var propertyId = this.property.Id;
      var userId = this.user.Id;
      var constData = {
        UtmId: this.utm_id,
        UtmSource: this.utm_source,
        UtmMedium: this.utm_medium,
        UtmCampaign: this.utm_campaign,
        UtmTerm: this.utm_term,
        UtmContent: this.utm_content,
        Propertyid: propertyId,
        UserId: userId,
        DocumentId: DocumentId
      };

      this._propertyManagerService.saveOfferingMemorandomToAuditLog(constData).subscribe(response => {
        ////this.bindLeadSummary();            
      });
    }
    else {
      this.nextTabToShow = this.propertyTabs.Memorandom;
      if (this.authService.user != null) {
        const logs = {
          UserId: this.user != null ? this.user.Id : 0,
          SourcePage: 'ViewProperty-saveOfferingMemorandomToAuditLog',
          RedirectionUrl: null
        }
        this.commonService.AddLogs(logs).subscribe(response => {
        });
      }
      document.getElementById("openModalButton").click();
    }

  }
  logUtmCodes() {
    var constData = {
      UtmId: this.utm_id,
      UtmSource: this.utm_source,
      UtmMedium: this.utm_medium,
      UtmCampaign: this.utm_campaign,
      UtmTerm: this.utm_term,
      UtmContent: this.utm_content,
      PropertyId: this.propertyGuid,
      UserId: (this.user != null && this.user != undefined) ? this.user.Id : 0
    };

    this.commonService.addUTMCodesToActivityLog(constData).subscribe(response => {
    });
  }

  updateTimestamp = {} as IUpdateTimestampModel;
  VerifyProperty(propertyId: number) {
    this.updateTimestamp.PropertyId = propertyId;
    this.updateTimestamp.UserId = this.user.Id;
    this._brokerageManagerService.UpdatePropertyTimeStamp(this.updateTimestamp).subscribe(resp => {
      this._toastService.addToast({
        title: 'Success',
        msg: this.property.IsPortfolio ? 'Portfolio verified' : 'Property verified',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });

      if (this.authService.Broker()) {
        this.updateTimestamp = {} as IUpdateTimestampModel;
        this.loadPageContent();
      }


    });
  }



  onBreadCrumbClick() {
    if (this.prevPage != 'Comps') {
      if (this.previousTab != null && this.previousTab != '') {
        this.router.navigateByUrl(this.prevPageRouteLink + "?activetab=" + this.previousTab);
      }
      else {
        if (this.prevPage != null && this.prevPage == "Market Snapshot") {
          this.router.navigate([this.prevPageRouteLink], { queryParams: { UserGuid: this.userGuid, opentab: 1 } });
        }
        else {
          this.router.navigateByUrl(this.prevPageRouteLink);
        }
      }
    }
    else {
      this.router.navigateByUrl("comps/" + this.prevPageRouteLink);
    }
  }

  lightbox_arr = [];
  open(index: number): void {
    this.lightbox_arr = [];
    if (this.only1PropImage) {
      let new_arr = {
        src: this.property.Images[0].FilePath,
        caption: this.property.Images[0].Id
      };
      this.lightbox_arr.push(new_arr);
      // open lightbox
      this._lightbox.open(this.lightbox_arr, 0);
    }
    else {
      this.property.Images.map((item) => {
        let new_arr = {
          src: item.FilePath,
          caption: item.Id
        };
        this.lightbox_arr.push(new_arr);

      });
      // open lightbox
      this._lightbox.open(this.lightbox_arr, index);
    }
  }
  openDeleteModal(template: TemplateRef<any>, classes: any, id: number, index: number) {
    this.selectedOfferId = id;
    this.currentIndex = index;
    this.modalRef = this.modalService.show(template, { class: classes });


  }
  deleteOffers() {
    var loggedinUserId = this.user.Id;
    var offerId = this.selectedOfferId;
    var index = this.currentIndex;
    if (offerId > 0) {
      this._propertyManagerService.deleteOffers(offerId, loggedinUserId).subscribe(response => {
        if (response.toString() == 'true') {
          this.offers.splice(index, 1);
          this._toastService.addToast({
            title: 'Success', msg:
              'Inquiry deleted successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Error', msg:
              'Error deleting inquiry', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }

      });
    }
  }
  tabToShow = null;
  showLikesAndViews = false;
  showNotes = false;
  ngOnInit() {
    document.body.classList.add('propertyDetails-body-div');
    var _newdocs = document.getElementById('be-floating-box1');
    if (_newdocs != null && _newdocs != undefined && !(_newdocs.classList.contains('be-floating-box-details'))) {
      _newdocs.classList.add('be-floating-box-details');

    }
    this.checkRoutes();
    localStorage.setItem("CurrentActivePage", JSON.stringify(this.currentDetailsPage));
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.setUserDetails();
    this.authSubscription.add(
      this.activatedRoute.queryParams.subscribe((params: Params) => {
        let routeName = params['prevroute'];
        this.prevRoute = routeName;
        let routeLink = params['link'];
        this.utm_id = params['utm_id'] ?? params['utmid'];
        this.utm_source = params['utm_source'] ?? params['utmsource'];
        this.utm_medium = params['utm_medium'] ?? params['utmmedium'];
        this.utm_campaign = params['utm_campaign'] ?? params['utmcampaign'];
        this.utm_term = params['utm_term'] ?? params['utmterm'];
        this.utm_content = params['utm_content'] ?? params['utmcontent'];
        this.shared_token = params['token'] ?? params['token'];
        this.sourceToken = params['sourcetoken'] ?? params['sourcetoken'];
        this.previousTab = params['dealTab'] ?? params['dealTab'];
        this.userGuid = params['UserGuid'] ?? "0000";
        this._auth0.PropertyToken = this.shared_token;

        this._auth0.PropertyGuid = this.propertyGuidSlug;
        if (routeName !== null && routeName !== undefined) {
          this.prevPage = routeName == 'Principal Dashboard' ? 'My Portal' : routeName;
          this.prevPageRouteLink = routeLink;
        }
        if (params['property_tab'] !== null && params['property_tab'] !== undefined) {
          this.tabToShow = params['property_tab'];
        }
        else if (params['tab'] !== null && params['tab'] !== undefined) {
          this.sourceTab = params["tab"];

        }
      })
    );
    //(<any>window).Intercom('boot', {
    //    app_id: environment.intercom_api,
    //    hide_default_launcher: false
    //});
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }

  checkRoutes() {
    const id = this.activatedRoute.snapshot.params.id || '';

    //this.activatedRoute.params.subscribe(params => {
    // console.log(params);
    this.propertyGuidSlug = id;
    ////this.generateMetaTags();
    this.defaultSearchCriteriaValues();
    this.activeTab = this.propertyTabs.Home;

    this.defaultProfilePic = '/assets/img/default-profile-img.png';
    this.authSubscription.add(
      this.authService.isLoggedIn.subscribe(response => {
        let url = this.router.url;
        this.setUserDetails();
        if (url.toString().indexOf("/viewproperty") != -1 && !this.IsEditClick) {
          this.loadPageContent();

        }
      })
    );
    //   });
    
     }

  nextTabToShow = this.propertyTabs.Home;
  showPlaceOffer = true;
  setUserDetails() {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.user = this.authService.user != null ? this.authService.user : '';
    if (this.isUserLoggedIn) {
      let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
      this.user = loggedUserDetails;
      this.loggedInUserId = this.user.Id;
      if (this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff)) {
        this.canEditProperty = true;
        this.showPlaceOffer = false;
        this.canEditPropertyForBroker = true;
        this.viewBrokerage = true;
      }
      if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
        this.canEditProperty = true;
        this.showPlaceOffer = true;
        this.canEditPropertyForBroker = true;
        this.visewDocRequestList = true;
        this.viewActivityLog = true;
        this.viewBrokerage = true;
      }
      else if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
        this.canEditProperty = true;
        this.canEditPropertyForBroker = false;

        if (this.property != undefined && this.property.PropertyContactPersonsList != undefined && this.property.PropertyContactPersonsList.filter(i => i.UserId == this.user.Id).length > 0) {
          this.visewDocRequestList = true;
          this.viewNotifications = true;
        }

        this.viewBrokerage = true;
      }
      if (this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
        this.enableMessage = true;
      }

      if (this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff) || this.property.PropertyStatus == 'BOV' || this.property.PropertyStatus == 'Pre-Marketing') {
        this.enableShare = false;

      }
      else {
        this.enableShare = true;

      }
      if (this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
        this.showAddToFav = true;
      }

      if (this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
        this.showPlaceOffer = true;
      }
    }
  }
  slideConfig = {
    "slidesToShow": 1, "slidesToScroll": 1, "speed": 800, "centerMode": false, "dots": true, "variableWidth": true, "autoplay": false, "autoplaySpeed": 2000, "infinite": true,
  };
  mapProp: any;
  loadPageContent() {
    this.loaderService.display(true);

    this.defaultDocAccessOutput();
    if (this.isUserLoggedIn == false) {
      if (this.user != "") {
        this.user.Id = 0;
      }
    }
    this._propertyService.getPropertyDetails(this.propertyGuidSlug, this.user.Id).subscribe(response => {
      if (response != null && !response.IsAccessDenied && !response.IsPropertyExist) {
        this.property = response;
        if (this.property.ConfidentialLocation && !this.property.IsPortfolio && !this.authService.Admin() && !this.authService.SuperAdmin() && !this.authService.Broker() && !this.authService.DataEntryStaff()) {
          this.haveaccesstoviewlocation = false;
        }
        else {
          this.haveaccesstoviewlocation = true;
        }
        this.propertyGuid = this.property.Guid;
        this.Token = this.property.Token;
        let locationText = this.property != null && (this.property.City != null && this.property.City != undefined) ? ', ' + this.property.City : '';
        locationText = locationText != null && locationText != '' ? this.property != null && (this.property.StateCode != null && this.property.StateCode != undefined) ? locationText + ', ' + this.property.StateCode : locationText : '';
        this.currentsharedtext = "Download OM - " + this.property.Tenant + locationText;
        if (!this.property.IsPortfolio && this.property.ConfidentialLocation) {
          this.currentsharedtext = "Download OM - " + this.property.Tenant + ', Confidential';
        }
        if (this.Token != null && this.Token != "") {
          this.currentsharedurl = this.Site_URL + "/viewproperty/" + this.propertyGuidSlug + "?token=" + this.Token + "&utm_medium=link&utm_source=be_web&utm_campaign=ShareListing&utm_content=link";
        }
        else {
          this.randomToken = this.randomString(10);
          this.currentsharedurl = this.Site_URL + "/viewproperty/" + this.propertyGuidSlug + "?token=" + this.randomToken + "&utm_medium=link&utm_source=be_web&utm_campaign=ShareListing&utm_content=link";

        }
        if (this.property.TCAccepted != true && !this.authService.IsTcModalCalled&& (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker))) {
          if (sessionStorage.getItem('viewproperty') == null || sessionStorage.getItem('viewproperty') == undefined) {
            this._propertyService.logout();
          }
          else {
            sessionStorage.removeItem('viewproperty');
          }
        }

        if ((this.utm_id != null && this.utm_id != undefined) || (this.utm_campaign != null && this.utm_campaign != undefined) || (this.utm_source != null && this.utm_source != undefined) || (this.utm_content != null && this.utm_content != undefined) || (this.utm_term != null && this.utm_term != undefined) || (this.utm_medium != null && this.utm_medium != undefined)) {
          this.logUtmCodes();
        }

        if (this.property.PropertyCharacteristicsList.length > 0) {
          this.property.PropertyCharacteristicsList.forEach(item => {
            this.characterstics += item.Description + ", ";
          });
          this.characterstics = this.characterstics.slice(0, -2)
        }
        else {
          this.characterstics = '-'
        }

        if (this.prevRoute == "Comps") {
          this.nextTabToShow = this.propertyTabs.Comps;
        }
        else if (this.prevRoute != "Comps" && (this.authService.Admin() || this.authService.SuperAdmin() || this.property.IsPropertyDashboardEnabled ||
          ((this.property.PropertyStatus == 'BOV' || this.property.PropertyStatus == 'Pre-Marketing') && (this.authService.Seller() || this.authService.Broker()))) && this.property.PropertyForId == 601) {
          this.nextTabToShow = this.propertyTabs.Dashboard;
        }
        if (this.property.IsPortfolio || this.property.ParentPortfolioName != '') {
          this.BindColumns();
          if (this.dtElement) {
            this.dtElement.dtInstance.then(x => x.draw());
          }
          else {
            this.bindTable(this.propertyGuid);
          }
        }

        if (this.property.PropertyCharacteristicsList.filter(x => x.Id == 2908).length > 0 || this.property.OnlyZCF) {
          this.capratetext = 'ZCF';
        }
        else {
          this.capratetext = 'Cap Rate';
        }
        this.getCurrentUrl();
        this.propertyGuid = response.Guid;
        this.isPropertyForSale = this.property.PropertyForId === 601;
        this.canEditHistory = (this.isUserLoggedIn && this.canEditProperty && this.canEditPropertyForBroker && (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || (this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff) && this.isPropertyForSale == false)));
        this.propertyLatitude = response.Latitude != null ? parseFloat(response.Latitude) : 40.730610;
        this.propertyLongitude = response.Longitude != null ? parseFloat(response.Longitude) : -73.935242;
        this.docAccessOutput.PropertyId = this.property.Id;
        this.propertyId = this.property.Id;
        if (this.property.IsFav == true) {
          this.classToBind = 'favClicked';
          this.toolTipFav = "Remove from favorites";
        }

        response.LeaseCommencementDate = this.Validation.convertUTCDateToLocalDate(response.LeaseCommencementDate);
        response.LeaseExpirationDate = this.Validation.convertUTCDateToLocalDate(response.LeaseExpirationDate);
        //this.property.RemainingTerm = this.Validation.daysBetweenDates(response.LeaseExpirationDate, response.LeaseCommencementDate);
        this.property.Remaining_Term = this.Validation.getRemainingTerm(response.LeaseExpirationDate, response.LeaseCommencementDate);

        if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
          this.savePropertyAccessLogModel.PropertyId = this.propertyId;
          this.savePropertyAccessLogModel.UserId = this.user.Id;
          this._propertyService.savePropertyAccessLog(this.savePropertyAccessLogModel).subscribe(response => {
          });
        }
        if ((this.authService.IsUserRole(this.authService.UserRole.Principal1031) && this.property.PropertyForId == 602) || !this.isUserLoggedIn || this.property.PropertyStatus == 'BOV' || this.property.PropertyStatus == 'Pre-Marketing') {
          this.enableShare = false;
        }
        if (this.isUserLoggedIn) {
          if (this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
            this.showLikesAndViews = true;
          }

          if (this.authService.IsUserRole(this.authService.UserRole.Principal1031) && !this.isPropertyForSale) {
            this.showContactUs = false;
          }
          this.commonService.GetPropertyContactPersonList(this.property.Id).subscribe(resp => {
            if (resp.length != 0) {
              let isContactUserLoggerdin = resp.find(x => x.UserId == this.user.Id);
              if (isContactUserLoggerdin != undefined) {
                this.viewActivityLog = true;
         if (this.authService.IsUserRole(this.authService.UserRole.Broker))
               {
                this.viewNotifications=true;
               }
                this.isContactPerson = true;
                this.accessAdded = 1;
              }
            }
          });
        }

        let defaultImage = [];
        let images = this.property.Images;
        if (this.staticTabs.tabs.length > 0) {
          if (images.length > 0 || (this.property.IsPortfolio && this.property.PortfolioPropertyIds.length == 0)) {
            this.staticTabs.tabs[0].active = true;
          }
          else {
            this.staticTabs.tabs[1].active = true;
            if (this.property.Latitude != "0" && this.property.Longitude != "0") {
              this.staticTabs.tabs[1].active = true;
            }
            else {
              this.showmap = false;
              this.staticTabs.tabs[0].active = true;
            }
          }
        }

        if ((this.property.Latitude == null && this.property.Longitude == null) || (this.property.Latitude == '0' && this.property.Longitude == '0') || !this.haveaccesstoviewlocation) {
          this.showmap = false;
          if (this.staticTabs != null && this.staticTabs.tabs.length > 0&& this.staticTabs.tabs[0] != null) {
            this.staticTabs.tabs[0].active = true;
          }
        }

        if (this.property.VideoURL != null && this.property.VideoURL != '') {
          this.commonService.getIdFromUrl(this.property.VideoURL).subscribe(res => {
            this.videoUrlResponse = res;
            let actualVideoUrl = "https://player.vimeo.com/video/" + this.videoUrlResponse.video_id;
            this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(actualVideoUrl);
          });
        }

        if (this.property.PropertyContactPersonsList != null) {

          for (let item of this.property.PropertyContactPersonsList) {
            if (item.ContactTypeId == ContactType.Others) {
              this.hasOtherContactType = true;
            }
            else {
              this.hasOtherContactType = false;
            }
          }

        }

        if (this.property.Latitude != "0" && this.property.Longitude != "0") {
          this.mapProp = {
            center: new google.maps.LatLng(this.propertyLatitude, this.propertyLongitude),
            draggableCursor: 'auto',
            zoom: 15,
            zoomControlOptions: {
              position: google.maps.ControlPosition.LEFT_CENTER,
            },
            streetViewControlOptions: {
              position: google.maps.ControlPosition.LEFT_CENTER,
            },
            mapTypeControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
          };

          this.setMap();
        }
        else {
          this.showmap = false;
        }


        this.documentList();

        this.getdocAccessDetails();

        //this._propertyService.GetSimilarProperties(this.property.Id, this.loggedInUserId).subscribe(response => {
        //  this.similarProperties = response;
        //  this.similarPropertiesCount = response[0].TotalCount;
        //});

        if (this.user.Role !== undefined) {
          if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
            if (this.nextTabToShow === this.propertyTabs.SendInquiryPopup) {
              $("#btnSentInquiry").click();
            }
            else if ((this.nextTabToShow !== this.propertyTabs.PlaceOffer) || (this.property.PropertyStatus === 'Available' && this.property.OfferPlaced == 0 && this.nextTabToShow === this.propertyTabs.PlaceOffer)) {
              this.activeTab = this.nextTabToShow;
            }
          }
          else if (this.nextTabToShow !== this.propertyTabs.SendInquiryPopup && this.nextTabToShow !== this.propertyTabs.PlaceOffer) {
            this.activeTab = this.nextTabToShow;
          }
        }
        this.GetMessageUnreadMessageCount();
        this.setActiveTab();
        this.loaderService.display(false);
      }
      else {
        if (this.authService.logoutClicked == false) {
          this.loaderService.display(false);
          //this._toastService.clearAllToast();
          if (response.IsAccessDenied) {
            this._toastService.addToast({ title: 'Property Not Available', msg: "The property you are trying to view is not available", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          }
          else {
            this._toastService.addToast({ title: 'Property Not Available', msg: "The property you are trying to view is not available", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          }

          if (this.prevRoute != null)
            this.router.navigateByUrl(decodeURIComponent(this.prevPageRouteLink));
          else
            this.router.navigateByUrl(this.prevPageRouteLink);
        }
        else {
          this.authService.logoutClicked = false;
        }

      }
      this.showNotes = true;
      if (this.shared_token != null && this.shared_token != "" && this.Token == this.shared_token && this.property != null && this.property.PropertyStatus != "BOV" && this.property.PropertyStatus != "Pre-Marketing") {
        this.getUserCount(this.propertyId);
        this.activeTab = this.propertyTabs.Memorandom;
        this.tabToShow = "Memorandom";
        this.onTabClick(this.propertyTabs.Memorandom);
      }
      if (this.sourceTab != null && this.sourceTab != '' && this.property != null && (this.sourceTab == 'Diligence' || this.sourceTab == 'Memorandom') && this.property.PropertyStatus != "BOV" && this.property.PropertyStatus != "Pre-Marketing") {
        this.activeTab = this.sourceTab == 'Diligence' ? this.propertyTabs.Diligence : this.propertyTabs.Memorandom;
        //this.tabToShow = "Diligence";
        this.onTabClick(this.activeTab);
      }
      else {
        if (this.sourceTab != null && this.sourceTab != '' && this.property != null) {
          this.activeTab = this.propertyTabs.Dashboard;
          //this.tabToShow = "Dashboard";
          this.onTabClick(this.propertyTabs.Dashboard);
        }
      }
      if (this.sourceToken != null && this.sourceToken != '') {
        if (this.sourceTab != null && this.sourceTab != '' && this.sourceTab != undefined) {
          this.activeTab = this.sourceTab == 'Diligence' ? this.propertyTabs.Diligence : this.propertyTabs.Memorandom;
        }
        else {
          this.onTabClick(this.propertyTabs.Diligence);
        }
      }
    })

  }

  private generateMetaTags() {
   /* this.propertyGuidSlug = '/jared-jewelers-houston-tx';*/
    const promise = this.http.get<MetaTagData>(this.BASE_URL + '/property/metatagdata/' + this.propertyGuidSlug).toPromise();
    promise.then((data) => {
      if (data != null && data.Images != null && data.Images.length > 0) {
        this.Images = data.Images;
        if (this.Images.length == 1) {
          this.only1PropImage = true;
          this.Images.push(this.Images[0]);
        }
      }
      var caprate = data.CharacteristicsId ? 'ZCF' : data.CapRate + '% Cap Rate'
      this.metaTag.addTag({ property: "og:site_name", content: 'B+E' });
      this.metaTag.addTag({ property: "og:type", content: 'website' });
      this.metaTag.addTag({ property: "og:title", content: data.Tenant + ' | ' + (data.Unpriced ? 'Unpriced' : data.Price) + (data.Unpriced ? '' : ' | ' + caprate) });
      this.metaTag.addTag({ property: "og:description", content: data.FullAddress });
      this.metaTag.addTag({ property: "og:image", content: data.DefaultImage != null ? data.DefaultImage : window.location.hostname + '/assets/img/defaultbanner-min.png' });
      this.metaTag.addTag({ property: "og:image:width", content: '1200' });
      this.metaTag.addTag({ property: "og:image:height", content: '628' });
      this.metaTag.addTag({ property: "og:url", content: this.Site_URL + '/viewproperty/' + this.propertyGuidSlug });

      //Twitter Meta tags Start
      this.metaTag.addTag({ name: "twitter:site", content: 'B+E' });
      this.metaTag.addTag({ name: "twitter:card", content: 'summary_large_image' });
      this.metaTag.addTag({ name: "twitter:title", content: data.Tenant + ' | ' + (data.Unpriced ? 'Unpriced' : data.Price) + (data.Unpriced ? '' : ' | ' + caprate) });
      this.metaTag.addTag({ name: "twitter:description", content: data.FullAddress });
      this.metaTag.addTag({ name: "twitter:image", content: data.DefaultImage != null ? data.DefaultImage : window.location.hostname + '/assets/img/defaultbanner-min.png' });
      //Twitter Meta tags End
      var IsNotPermitted = 0;
      if (!this.authService.Admin() && !this.authService.SuperAdmin() && !this.authService.Broker() && !this.authService.DataEntryStaff()) {
        IsNotPermitted = 1;
      }
      this.title.setTitle(data.Title ? data.ConfidentialLocation && IsNotPermitted == 1 ? data.Tenant : data.Title : "B+E Buy Net Lease Properties");
      // Custom tag
      this._propertyManagerService.createLinkForCanonicalURL(this.Site_URL + '/property/details/' + this.propertyGuidSlug);
      if (data.MetaTagDescription != null) {
        this.metaTag.addTag({ name: "description", content: data.MetaTagDescription });
      }

      if (data.MetaTag != null) {
        this.metaTag.addTag({ name: "keywords", content: data.MetaTag });
      }
    }).catch((error) => {
      console.log("Promise rejected with " + JSON.stringify(error));
    });
  }

  selectedColumns = [];
  //defaultTypeText: IMultiSelectTexts = {
  //  defaultTitle: 'Select Columns',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Columns",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  }

  private setMap(isSatellite = false) {
    if (!isSatellite) {
      this.mapProp.mapTypeId = google.maps.MapTypeId.ROADMAP;
      this.map = new google.maps.Map(this.gmapElement.nativeElement, this.mapProp);
    }
    else {
      this.mapProp.mapTypeId = google.maps.MapTypeId.SATELLITE;
      this.map = new google.maps.Map(this.gmapSatelliteElement.nativeElement, this.mapProp);
    }

    setTimeout(() => { this.setCenter(); }, 10);
  }

  hideColumn(col: number) {
    if (this.selectedColumns.indexOf(col) > -1) {
      return false; // show
    }
    else {
      return true; // hide
    }
  }

  searchCriteriaForExport = {} as IPropertySearchCriteria;
  exportToExcel() {
    this.TableColumns = [
      { data: 'Id' },
      { data: 'TenantName' },
      { data: 'OM' },
      { data: 'State' },
      { data: 'City' },
      //{ data: 'PropertyType' },
      { data: 'PropertyStatus' },
      { data: 'Price' },
      { data: 'RentNOI' },
      { data: 'Rank' }]
    this.loaderService.display(true);
    this.searchCriteriaForExport = this.searchCriteria;
    this.searchCriteriaForExport.IsExport = true;
    var loggedinUserId = this.user.Id;
    const inputModel =
    {
      Extra_param: this.searchCriteria
    }

    let dataTablesParameters = inputModel;

    dataTablesParameters.Extra_param = this.searchCriteriaForExport;
    dataTablesParameters.Extra_param.IsArchive = false;
    dataTablesParameters.Extra_param.IsComp = true;
    this.http.post<string>(this.BASE_URL + '/property/portfolioProperties/' + this.propertyGuid + '/' + this.loggedInUserId, dataTablesParameters).subscribe(resp => {
      let filenameWithExtension: string = resp.toString();
      let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
      this.Validation.downloadExcelFile('/upload/excelfile/' + filenameWithoutExtension, 'Portfolio Properties.xlsx');
      this.loaderService.display(false);
    });
  }


  tableColumns: collapseColumns[] = [];
  BindColumns() {
    this.tableColumns = [
      { id: 1, name: 'OM' },
      { id: 2, name: 'State' },
      { id: 3, name: 'City' },
      //{ id: 4, name: 'Property Type' },
      { id: 5, name: 'Status' },
      { id: 6, name: 'Price' },
      { id: 7, name: 'RentNOI' },
      { id: 8, name: 'CapRate' },
      { id: 9, name: 'RemainingTerm' }
    ]
    this.selectedColumns = [];
    if (localStorage.getItem("portfolio_property_listings_selectedColumns_LS") !== null) {
      this.selectedColumns = JSON.parse(localStorage.getItem("portfolio_property_listings_selectedColumns_LS"));
    }
    else {
      this.tableColumns.forEach(item => {
        this.selectedColumns.push(item.id);
      });
    }
    this.onRedirection();
  }


  onRedirection() {
    localStorage.setItem("portfolio_property_listings_selectedColumns_LS", JSON.stringify(this.selectedColumns));
  }


  bindTable(propertyGuid) {

    this.TableColumns = [
      { data: 'Id' },
      { data: 'Id' },
      { data: 'TenantName' },
      { data: 'OM', orderable: false },
      { data: 'State' },
      { data: 'City' },
      //{ data: 'PropertyType' },
      { data: 'PropertyStatus' },
      { data: 'Price' },
      { data: 'RentNOI' },
      { data: 'CapRate' },
      { data: 'RemainingTerm' },
      { data: 'Rank' }]

    //{ data: 'CapRate' },
    //{ data: 'RemainingTerm' },
    //{ data: 'BuildingSize' },
    //{ data: 'LeaseStructure' }

    this.loaderService.display(true);
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      "pageLength": 50,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
      },
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/property/portfolioProperties/' + that.propertyGuid + '/' + this.loggedInUserId, dataTablesParameters).subscribe(resp => {
            this.portfolioProperties = resp.data ? resp.data : [];
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
          });
        this.loaderService.display(false);
      },
      columns: that.TableColumns
    };
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  setActiveTab() {
    if (this.tabToShow != null) {
      if (this.tabToShow === "inquiry") {
        this.activeTab = PropertyTabs.Inquiries;
      }
      else if (this.tabToShow === "Offer") {
        this.activeTab = PropertyTabs.Offer;
      }
      else if (this.tabToShow === "Memorandom") {
        this.activeTab = PropertyTabs.Memorandom;
      }
      else if (this.tabToShow === "analytics") {
        this.activeTab = PropertyTabs.Analytics;
      }
      else {
        this.activeTab = PropertyTabs.Home;
      }
    }
  }

  showOffer(status: boolean) {
    if (status) {
      this.showPlaceOffer = true;
      this.placeOfferVisibility = true;
      this.openPlaceOfferTab(this.propertyTabs.PlaceOffer);
    }
    else {
      this.showPlaceOffer = false;
      this.placeOfferVisibility = false;
    }
  }

  setCenter() {
    let bounds = new google.maps.LatLngBounds();
    if (this.property.IsPortfolio) {
      this.property.PortfolioProperties.forEach(item => {
        let location = new google.maps.LatLng(parseFloat(item.Latitude), parseFloat(item.Longitude));
        let marker = new google.maps.Marker({
          position: location,
          map: this.map,
          title: item.PropertyName + ", " + item.Address
        });

        let loc = new google.maps.LatLng(parseFloat(item.Latitude), parseFloat(item.Longitude));
        bounds.extend(loc);
      })
      this.map.fitBounds(bounds);

      setTimeout(() => { google.maps.event.trigger(this.map, "resize"); }, 5)

    }
    else {
      this.map.setCenter(new google.maps.LatLng(this.propertyLatitude, this.propertyLongitude));
      let location = new google.maps.LatLng(this.propertyLatitude, this.propertyLongitude);
      let marker = new google.maps.Marker({
        position: location,
        map: this.map,
        title: this.property.Address
      });
    }
  }

  onToggleDescriptionVisibility() {
    if (this.isDescriptionVisible) {
      this.toggleDetailsText = '-Show Details';
      this.isDescriptionVisible = false;
    }
    else {
      this.toggleDetailsText = '-Hide Details';
      this.isDescriptionVisible = true;
    }
  }

  onTabClick(tab: number) {
    if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
      localStorage.removeItem('currentFileRefreshTab');
    }
    if (!this.isUserLoggedIn && tab != PropertyTabs.Analytics && tab != PropertyTabs.Home && tab != PropertyTabs.Message && tab != PropertyTabs.Memorandom) {
      this.nextTabToShow = tab;
      document.getElementById("openModalButton").click();
    }
    else if (tab == PropertyTabs.Memorandom) {
      this.getUserCount(this.propertyId);
      this.getdocAccessDetails();
      if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
        if (this.property != undefined && this.property.PropertyContactPersonsList != undefined && this.property.PropertyContactPersonsList.filter(i => i.UserId == this.user.Id).length > 0) {
          this.visewDocRequestList = true;
  if (this.authService.IsUserRole(this.authService.UserRole.Broker))
      {
          this.viewNotifications=true;
        }
        }
        else {
          this.visewDocRequestList = false;
        }
      }
      if (this.isUserLoggedIn) {
        this.activeTab = tab;
      }
      else {
        this.nextTabToShow = tab;
        if (this.authService.user != null) {
          const logs = {
            UserId: this.user != null ? this.user.Id : 0,
            SourcePage: 'ViewProperty-Ontabclick',
            RedirectionUrl: null
          }
          this.commonService.AddLogs(logs).subscribe(response => {
          });;
        }
        document.getElementById("openModalButton").click();
      }
    }
    else if (tab == PropertyTabs.Diligence) {
      this.activeTab = this.propertyTabs.Diligence;
    }
    else if (tab == PropertyTabs.Message) {
      if (this.authService.Admin() || this.authService.SuperAdmin() || (this.authService.Seller() && this.property.IsPropertyDashboardEnabled)) {
        this.commonService.GetPropertyContactPersonList(this.property.Id).subscribe(response => {
          var broker = response.filter(i => i.Role == "B+E Broker");

          this.propertyChatModel.ExchangeId = 0;
          this.propertyChatModel.PropertyGuid = this.property.Guid;
          this.Shared.clickMessage(this.propertyChatModel);
          this.isContactPerson = true;
          //}
          //else {
          //  this._toastService.addToast({ title: 'No Groups found', msg: "You cant send messages. No conversation group identified for this property.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })

          //}
        });
      }
      else {
        this.propertyChatModel.PropertyGuid = this.property.Guid;
        this.Shared.clickMessage(this.propertyChatModel);
      }

    }
    else {
      this.activeTab = tab;
      if (tab == 9) {
        this.unreadMessageCount = 0;
      }
    }
  }
  openPlaceOfferTab(tab: number) {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.placeOfferInputModel.PropertyId = this.property.Id;
    this.fromOfferMatrix = false;
    if (this.isUserLoggedIn) {
      if ((this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031)) || this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker) || this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {

        this.activeTab = tab;
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal or broker user to place an offer", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
    else {
      //this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to place an offer", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      this.nextTabToShow = tab;
      document.getElementById("openModalButton").click();
    }
  }

  onVideoTabClick(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  onBannerTabClick(tab: number) {
    this.activeBannerTab = (tab == 3 ? 2 : tab);
    if (tab == 3) {
      setTimeout(() => this.setMap(tab == 3), 100)
    }
    if (tab == 2) {
      setTimeout(() => this.setMap(), 100);
    }
  }

  onSimilarPropertiesClick() {

    this._propertyService.fromHome = true;
    this._propertyService.criteria = this.searchCriteria;
    this.router.navigate(['/propertylisting']);
  }

  defaultSearchCriteriaValues() {
    this.searchCriteria.SkipCount = 0;
    this.searchCriteria.TakeCount = 20;
    this.searchCriteria.Address = '';
    this.searchCriteria.AssetTypes = [];
    this.searchCriteria.PriceFrom = null;
    this.searchCriteria.PriceTo = null;
    this.searchCriteria.Tenants = [];
    this.searchCriteria.Ratings = [];
    this.searchCriteria.Terms = [];
    this.searchCriteria.SortValue = "PLH";
  }

  onViewPropertyEvent(guid: string) {
    this.propertyGuid = guid;
    this.ngOnInit();
  }

  public getOfferPlaced(offerPlaced: any): void {
    this.property.OfferPlaced = offerPlaced;
  }

  public getInquiryPlaced(inquiryPlaced: any): void {
    this.property.InquiryPlaced = inquiryPlaced;
  }



  openInquiryModal(template: TemplateRef<any>, classes: any) {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.placeOfferInputModel.PropertyId = this.property.Id;

    if (this.isUserLoggedIn) {
      if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
        if (this.property.InquiryPlaced == 0) {
          this.showFileUpload = false;
          this.modalRef = this.modalService.show(template, { class: classes });
        }
        else {
          this._toastService.addToast({ title: 'Unable to Complete the Action', msg: "You have already submitted inquiry for this property", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal user to submit an inquiry", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })

      }
    }
    else {
      //this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to send an Inquiry.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      this.nextTabToShow = this.propertyTabs.SendInquiryPopup;
      document.getElementById("openModalButton").click();
    }
  }

  openLoginModal(template: TemplateRef<any>, classes: any, guid) {
    this._auth0.PropertyGuid = this.propertyGuidSlug;
    this._auth0.PropertyToken = this.shared_token;
    if (this.authService.isAuth0Enabled) {
      this._auth0.login();
    }
    else {
      this.modalRef = this.modalService.show(template, { class: classes });
    }
  };


  onEditPropertyClick() {
    this.IsEditClick = true;
    if (this.property.IsPortfolio) {
      this.router.navigate(['/property/' + (this.propertyGuidSlug ? this.propertyGuidSlug : this.property.Guid)], { queryParams: { prevroute: this.prevPage, link: this.prevPageRouteLink, isPortfolio: true } });
    }
    else {
      this.router.navigate(['/property/' + (this.propertyGuidSlug ? this.propertyGuidSlug : this.property.Guid)], { queryParams: { prevroute: this.prevPage, link: this.prevPageRouteLink } });
    }
  }

  documentList() {
    if (this.property.Documents != null && this.property.Documents.length > 0) {
      let docsOfferingMemorandom = this.property.Documents.filter(i => i.CategoryId === DocumentType.OfferingMemorandom);
      let docsDueDiligence = this.property.Documents.filter(i => i.CategoryId != DocumentType.OfferingMemorandom && i.IncludeInDD);

      this.offeringMemorandomDocList = docsOfferingMemorandom;
      this.dueDiligenceDocList = docsDueDiligence;

    }
  }
  isMemorandomTandC = false;
  onMemorandomProceedClick() {
    if (this.isUserLoggedIn) {
      this.loaderService.display(true);

      this.docAccessOutput.RequestForOfferAccessId = this.property.OfferMemoReqApproval ? this.docAccessOutput.RequestForOfferAccessId != DocAccessStatus.Accepted ? DocAccessStatus.Pending : DocAccessStatus.Accepted : DocAccessStatus.New;
      this.docAccessOutput.IsPrincipal = true;
      this.docAccessOutput.DocumentType = DocumentType.OfferDocAccess;
      this.user = this.authService.user;
      var userId = this.user.Id;
      this.docAccessOutput.LoggedinUserId = userId;
      this.docAccessOutput.IsCAAccepted = this.isMemorandomTandC || this.docAccessOutput.IsCAAccepted;
      this.docAccessOutput.CADocId = this.caDocId;
      this._propertyService.saveAccessRequestForDocuments(this.docAccessOutput).subscribe(response => {
        if (response != null) {
          if (this.docAccessOutput.RequestForOfferAccessId == DocAccessStatus.Pending) {
            this._toastService.addToast({ title: 'Success', msg: "You can download the offering memorandom document after admin approval", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          }
          else {
            this._toastService.addToast({ title: 'Success', msg: "You can now download the offering memorandom document", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          }
        }
        this.loaderService.display(false);
      });
    }
    else {
      this.nextTabToShow = this.propertyTabs.Memorandom;
      document.getElementById("openModalButton").click();
    }

  }

  defaultDocAccessOutput() {
    this.docAccessOutput.PropertyId = this.property.Id;
    this.docAccessOutput.UserId = this.user.Id;
    this.docAccessOutput.RequestForOfferAccessId = DocAccessStatus.New;
    this.docAccessOutput.RequestForDueDiligenceAccessId = DocAccessStatus.New;
    this.docAccessOutput.IsPrincipal = false;
  }

  GetMessageUnreadMessageCount() {
    this.messageInput.CreatedById = this.user.Id;
    this.messageInput.ObjectId = this.property.Id
    this.messageInput.ObjectTypeId = 302;
    this.commonService.GetMessageUnreadMessageCount(this.messageInput).subscribe(responds => {
      this.unreadMessageCount = responds;
    });
  }
  afterChange(e) {

  }

  openPropertyShareModal(template: TemplateRef<any>, classes: any, tab) {
    if (!this.isUserLoggedIn) {
      this.nextTabToShow = this.propertyTabs.Home;
      document.getElementById("openModalButton").click();
    }
    else {
      this.modalRef = this.modalService.show(template, { class: classes });
    }
  }

  shareOnSocialMedia(media: number) {
    this.getCurrentUrl();
    if (media == SocialMedia.Twitter) {
      window.open('https://twitter.com/intent/tweet?url=' + this.currentUrl + encodeURIComponent('&utm_medium=post&utm_source=twitter&utm_campaign=ShareListing&utm_content=link'), '_blank');
    }
    else if (media == SocialMedia.FB) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + this.currentUrl + encodeURIComponent('&utm_medium=post&utm_source=fb&utm_campaign=ShareListing&utm_content=link'), '_blank');
    }
    else if (media == SocialMedia.LinkedIn) {
      window.open('https://www.linkedin.com/sharing/share-offsite/?url=' + this.currentUrl + encodeURIComponent('&utm_medium=post&utm_source=linkedin&utm_campaign=ShareListing&utm_content=link'), '_blank');
    }
  }

  //add to favorites section - start
  showAddToFav = false;
  addToFavorites = {} as IAddToFavorites;
  classToBind = 'fav';
  toolTipFav = "Add to favorites";
  @ViewChild('addToExchange') addToExchange: TemplateRef<any>;
  modalRefAddToExchange: BsModalRef;
  exchangeCodes: any[];
  private getCurrentUrl() {
    let generateRandomNumber = Math.floor(100000 + Math.random() * 900000);
    this.currentUrl = this.Site_URL + '/viewproperty/' + this.propertyGuidSlug + "?key" + generateRandomNumber.toString();
  }

  addToFav(propertyId: any) {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.user = this.authService.user;
    if (this.isUserLoggedIn) {
      if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
        this.addToFavorites.UserId = this.user.Id;
        this.addToFavorites.PropertyId = propertyId;
        if (!this.property.IsFav) {
          if (!this.isPropertyForSale) {
            this.trade1031Service.GetExchangeCode(this.user.Id).subscribe(res => {
              this.exchangeCodes = res;
              if (this.exchangeCodes.length > 1) {
                this.modalRefAddToExchange = this.modalService.show(this.addToExchange, {
                  class: 'panlestyle'
                });
              }
              else {

                this.saveAddToFav();
              }
            });
          }
          else {
            this.saveAddToFav();
          }
        }
        else {
          this.saveAddToFav();
        }
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal to mark as favorite.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
    else {
      this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to mark as favorite.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }
  private saveAddToFav() {
    this._propertyManagerService.addToFavorite(this.addToFavorites).subscribe(response => {
      if (response) {
        if (response == "1") {
          this.property.IsFav = true;
          this.classToBind = 'favClicked';
          this.toolTipFav = "Remove from favorites";
          this._toastService.addToast({
            title: 'Message', msg: 'This property has been added to your favorites.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else if (response == "2") {
          this.property.IsFav = false;
          this.classToBind = 'fav';
          this.toolTipFav = "Add to favorites";
          this._toastService.addToast({
            title: 'Message', msg: 'This property has been removed from your favorites.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        this.onSetActions();
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal to mark as favorite.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }

  addToExchangeSave(exchangeId: number[]) {
    this.addToFavorites.ExchangeId = exchangeId;
    this.saveAddToFav();
    this.modalRefAddToExchange.hide();
  }
  onSetActions() {
    if (this.property.IsFav == true) {
      this.classToBind = 'favClicked';
      this.toolTipFav = "Remove from favorites";
    }
    else {
      if (this.property.PropertyForId === 601) {
        this.classToBind = 'fav';
      }
      else {
        this.classToBind = 'favClicked55';
      }
    }
  }

  OMDocumentDisplayConditions() {

    if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff)) {
      return true;
    }
    else {
      if (this.property.ConfidentialityAgreement == true && this.property.OfferMemoReqApproval != true) {
        if (this.docAccessOutput.IsCAAccepted == true) {
          return true;
        }
        else {
          return false;
        }
      }
      if (this.property.ConfidentialityAgreement != true && this.property.OfferMemoReqApproval != true) {
        return true;
      }
      if (this.property.ConfidentialityAgreement != true && this.property.OfferMemoReqApproval == true) {
        if (this.docAccessOutput.RequestForOfferAccessId == this.docAccessStatus.Accepted) {
          return true
        }
        else {
          return false;
        }
      }
      if (this.property.ConfidentialityAgreement == true && this.docAccessOutput.IsCAAccepted == true) {
        if (this.property.OfferMemoReqApproval != true) {
          return true;
        }
        else {
          if (this.docAccessOutput.RequestForOfferAccessId == this.docAccessStatus.Accepted) {
            return true
          }
          else {
            return false;
          }
        }
      }
      else {
        return false;
      }
    }
  }

  DDDocumentDisplayConditions() {

    if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff)) {
      return true;
    }
    else {
      if (this.property.DDConfidentialityAgreement == true && this.property.DueDiligenceReqApproval != true) {
        if (this.docAccessOutput.IsCAAccepted == true) {
          return true;
        }
        else {
          return false;
        }
      }

      if (this.property.DDConfidentialityAgreement != true && this.property.DueDiligenceReqApproval != true) {
        return true;
      }
      if (this.property.DDConfidentialityAgreement != true && this.property.DueDiligenceReqApproval == true) {
        if (this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.Accepted) {
          return true
        }
        else {
          return false;
        }
      }
      if (this.property.DueDiligenceReqApproval == true && this.docAccessOutput.IsCAAccepted == true) {
        if (this.property.DueDiligenceReqApproval != true) {
          return true;
        }
        else {
          if (this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.Accepted) {
            return true
          }
          else {
            return false;
          }
        }
      }
      else {
        return false;
      }
    }
  }

  showHideMessages(menuType: number, messageType: number) {
    let show = false;
    if (menuType == 1) // Offering Memorandum
    {
      switch (messageType) {
        case 1: //No Data Available
          {
            if (this.offeringMemorandomDocList == null || this.offeringMemorandomDocList.length == 0) {
              if (this.property.OfferMemoReqApproval && this.docAccessOutput.RequestForOfferAccessId == this.docAccessStatus.Accepted) {
                show = !this.OMDocumentDisplayConditions();
              }
              else if (!this.property.OfferMemoReqApproval) {
                show = !this.OMDocumentDisplayConditions();
              }
            }
          }
          break;
        case 2:
          {
            if (this.offeringMemorandomDocList.length > 0 && this.offeringMemorandomDocList != null) {
              if (this.isUserLoggedIn) {
                this.showNodataOM = false;
                show = this.OMDocumentDisplayConditions();
              }
              else {
                this.showNodataOM = true;

              }
            }
            else {
              if (this.isUserLoggedIn) {
                this.showNodataOM = this.OMDocumentDisplayConditions();
              }
              else {
                this.showNodataOM = true;
              }
            }
          }
          break;
        case 3: //ConfidentialityAgreement True
          {
            if (this.property.ConfidentialityAgreement == true && !this.docAccessOutput.IsCAAccepted && !this.canEditProperty) {
              if (this.isUserLoggedIn) {
                show = true;
                this.showNodataOM = false;
              }
              else {
                this.showNodataOM = true;

              }

            }
          }
          break;
        case 4: // OfferMemoReqApproval
          {
            if (this.property.OfferMemoReqApproval && (this.docAccessOutput.RequestForOfferAccessId == this.docAccessStatus.New || this.docAccessOutput.RequestForOfferAccessId == null)) {
              if (this.isUserLoggedIn) {
                show = true;
                this.showNodataOM = false;
              }
              else {
                this.showNodataOM = true;

              }
            }
          }
          break;
        case 5: //OfferMemoReqApproval Pending Approval
          {
            if ((!this.property.ConfidentialityAgreement || this.docAccessOutput.IsCAAccepted == true)) {
              if (this.property.OfferMemoReqApproval && this.docAccessOutput.RequestForOfferAccessId == this.docAccessStatus.Pending && !this.canEditProperty) {
                if (this.isUserLoggedIn) {
                  show = true;
                  this.showNodataOM = false;
                }
                else {
                  this.showNodataOM = true;

                }
              }
            }
          }
          break;
        case 6: //OfferMemoReqApproval Rejected
          {
            if ((!this.property.ConfidentialityAgreement || this.docAccessOutput.IsCAAccepted == true)) {
              if (this.property.OfferMemoReqApproval && this.docAccessOutput.RequestForOfferAccessId == this.docAccessStatus.Rejected && !this.canEditProperty) {
                if (this.isUserLoggedIn) {
                  show = true;
                  this.showNodataOM = false;
                }
                else {
                  this.showNodataOM = true;

                }
              }
            }
          }
          break;
      }

    }
    else { // Due Diligence
      switch (messageType) {
        case 1://No Data Available
          {
            if (this.dueDiligenceDocList == null || this.dueDiligenceDocList.length == 0) {
              if ((this.property.DueDiligenceReqApproval && this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.Accepted && !this.canEditProperty))
                show = !this.DDDocumentDisplayConditions();
            }
          }
          break;
        case 2: // show files
          {
            if (this.dueDiligenceDocList.length > 0 && this.dueDiligenceDocList != null) {

              show = this.DDDocumentDisplayConditions();
            }
            else {
              this.showNodataDD = this.DDDocumentDisplayConditions();
            }
          }
          break;
        case 3: // sho dd confidentality mg
          {
            if (this.property.DDConfidentialityAgreement == true && !this.docAccessOutput.IsCAAccepted && !this.canEditProperty) {

              show = true;
              this.showNodataDD = false;
            }
          }
          break;
        case 4: // DueDiligenceReqApproval
          {
            if (this.property.DueDiligenceReqApproval && this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.New && !this.canEditProperty) {
              show = true
              this.showNodataDD = false;
            }
          }
          break;
        case 5: // dd pending approval
          {
            if ((!this.property.DDConfidentialityAgreement || this.docAccessOutput.IsCAAccepted == true)) {
              if (this.property.DueDiligenceReqApproval && this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.Pending && !this.canEditProperty) {
                show = true;
                this.showNodataDD = false;
              }
            }
          }
          break;
        case 6: //dd Reject
          {
            if ((!this.property.DDConfidentialityAgreement || this.docAccessOutput.IsCAAccepted == true)) {
              if (this.property.DueDiligenceReqApproval && this.docAccessOutput.RequestForDueDiligenceAccessId == this.docAccessStatus.Rejected && !this.canEditProperty) {
                show = true;
                this.showNodataDD = false;
              }
            }
          }
          break;
      }
    }

    return show;

  }

  modalRefDuplicate: BsModalRef;
  selectedPropertyIdForDuplicates = 0;
  openModalForDuplicates(template: TemplateRef<any>, classes: any, id) {
    this.selectedPropertyIdForDuplicates = id;
    this.modalRefDuplicate = this.modalService.show(template, { class: classes });
  }

  openModalForVerifyPropNote(template: TemplateRef<any>, classes: any) {
    this.modalRefVerify = this.modalService.show(template, { class: classes });
  }

  onOfferAnalyticsTabClick(tab: number) {
    this.comparePropertiesModel.UserId = this.user.Id;
    this.comparePropertiesModel.PropertyIds = this.property.PortfolioPropertyIds;
    this.comparePropertiesModel.IsPropertyAnalysis = false;
    this.comparePropertiesModel.IsOfferPortfolio = true;
    this._comparisonService.comparePropertiesModelData = this.comparePropertiesModel;
    console.log(JSON.stringify(this.comparePropertiesModel));
    this.activeTab = tab;
    this.comparePropertiesModel.Exchange1031Id = 0;
  }

  search = "";
  onViewProperty(Guid) {
    this.onRedirection();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.search = params['search'];
      this.isFav = params['isFav'] != undefined ? true : false;
      this.isDisliked = params['isDisliked'] != undefined ? true : false;
    });
    if (this.isFav) {
      this.router.navigateByUrl('viewproperty/' + Guid + '?prevroute=Favorites&link=' + encodeURIComponent(this.router.url));
    }
    else if (this.isDisliked) {
      this.router.navigateByUrl('viewproperty/' + Guid + '?prevroute=Disliked&link=' + encodeURIComponent(this.router.url));
    }
    else if (!this.Validation.IsinValid(this.search)) {
      this.router.navigateByUrl('viewproperty/' + Guid + '?prevroute=Saved Search&link=' + encodeURIComponent(this.router.url));
    }
    else {
      this.router.navigateByUrl('viewproperty/' + Guid + '?prevroute=Property List&link=' + encodeURIComponent(this.router.url));
    }
  }

  viewPlaceOffer(offerVisiblity) {
    if (offerVisiblity) {
      this.openPlaceOfferTab(this.propertyTabs.PlaceOffer);
      this.fromOfferMatrix = true;
    }
    else { }
  }
  onTabClickOM() {
    if (this.isUserLoggedIn) {
      this.getUserCount(this.propertyId);

      if (this.property.ConfidentialityAgreement && this.docAccessOutput.IsCAAccepted != true && !this.authService.Admin() && !this.authService.SuperAdmin() && !this.authService.Broker()
        || (this.property.OfferMemoReqApproval && (this.docAccessOutput.RequestForOfferAccessId == this.docAccessStatus.Pending || this.docAccessOutput.RequestForOfferAccessId == this.docAccessStatus.New || this.docAccessOutput.RequestForOfferAccessId == null) && !this.canEditProperty)) {
        this.onTabClick(this.propertyTabs.Memorandom);
      }
      else {
        if (this.offeringMemorandomDocList.length > 0 && this.browserService.document) {
          if (this.offeringMemorandomDocList[0].Id != null && this.offeringMemorandomDocList[0].Id > 0) {
            this.saveOfferingMemorandomToAuditLog(this.offeringMemorandomDocList[0].Id)
          }
          window.open(this.offeringMemorandomDocList[0].FilePath, '_blank');
        }
        else if (this.offeringMemorandomDocList == null || this.offeringMemorandomDocList.length <= 0) {
          this._toastService.addToast({
            title: 'No OM Found!',
            msg: 'There is no OM file to download.',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'warning',
          });
        }
      }
    }
    else {
      this.nextTabToShow = this.propertyTabs.Memorandom;
      if (this.authService.user != null) {
        const logs = {
          UserId: this.user != null ? this.user.Id : 0,
          SourcePage: 'ViewProperty-onTabClickOM',
          RedirectionUrl: null
        }
        this.commonService.AddLogs(logs).subscribe(response => {
        });
      }
      document.getElementById("openModalButton").click();
    }


  }

  OnPortfolioOMDownload(guid: string) {
    debugger;
    if (this.isUserLoggedIn) {

      let property;
      property = this.portfolioProperties.find(p => p.Guid == guid);
      if (property.OMFilePath != null && property.OMFilePath.length > 0) {
        window.open(property.OMFilePath, '_blank');
        }
      }    
    else {
      document.getElementById("openModalButton").click();
    }
  }

  sharedProperty = {} as ISharedProperty;
  private isTokenGenerated: boolean = true;
  private randomToken: string;
  copyMessage() {
    if (this.Token == null || this.Token == "") {
      if (this.randomToken != null && this.randomToken != "") {
        this.sharedProperty.PropertyId = this.propertyId;
        this.sharedProperty.Token = this.randomToken;
        this._propertyManagerService.copyLink(this.sharedProperty).subscribe(response => {
          if (!response) {
            this.isTokenGenerated = false;
          }
        });
      }
    }
    if (this.randomToken != null) {
      this.Token = this.randomToken;
    }
    if (this.isTokenGenerated == true && this.Token != null) {
      const from = document.getElementById('copyurl');
      var selection = window.getSelection();
      var range = document.createRange();
      from.style.display = 'block';
      range.selectNodeContents(from);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      var successful = document.execCommand('copy');
      document.getElementById('copyurl').style.display = 'none';
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copy url command was ' + msg);
    }
  }
  randomString(length) {
    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }
  //pdfDownload() {
  //    
  //    let that = this;
  //    $("body").removeClass("open-sidemenu");
  //    this.loaderService.display(true);
  //    setTimeout(() => {
  //        var divHeight = $('#agreement').height();
  //        var divWidth = $('#agreement').width();
  //        var ratio = divHeight / divWidth;
  //        var docDefinition = {};
  //        html2canvas(document.querySelector("#agreement"), {
  //            scale: 2,
  //            height: 'auto',
  //            width: divWidth + 20,
  //        }).then(function (canvas) {
  //            var data = canvas.toDataURL();
  //            docDefinition = {
  //                pageMargins: [30, 5, 5, 20],
  //                pageSize: {
  //                    width: 870,
  //                    height: 'auto'
  //                },
  //                content: [{
  //                    image: data,
  //                    width: 800,
  //                    height: (ratio * 870)
  //                }]
  //            };
  //            //pdfMake.createPdf(docDefinition).download(' - Analytics.pdf');
  //             const pdfDocGenerator = pdfMake.createPdf(docDefinition);
  //             pdfDocGenerator.getBlob((blob) => {
  //                 that.loaderService.display(false);
  //                 that.file = new File([blob], "CONFIDENTIALITYAGREEMENT.pdf", { type: "application/pdf", lastModified: Date.now() });
  //                 that.uploadFiles();
  //             });
  //        });
  //    }, 1000);
  //}

  //uploadFiles() {
  //    let that = this;
  //    this.loaderService.display(true);
  //    let valid = true;
  //    if (valid) {
  //        let uploadCount = 1;
  //        //this.filesCollection.forEach(item => {
  //        this.inputFileUpload.documentName = 'CONFIDENTIALITY AGREEMENT';//'item["name"]';
  //        this.inputFileUpload.fileCategoryId = 417;//item["category"];
  //        this.inputFileUpload.id = 0;
  //        this.inputFileUpload.objectId = this.propertyId;
  //        this.inputFileUpload.objectTypeId = 316;
  //        this.inputFileUpload.type = "Documents";

  //        let fileToUpload = [];
  //        fileToUpload.push(this.file);
  //        this._fileUploadService.uploadFiles(this.inputFileUpload, fileToUpload).subscribe(res => {
  //            if (res != null) {
  //                that.caDocId = res[0]["UploadedFileId"];
  //                that.onMemorandomProceedClick()
  //            }
  //        });

  //    }
  //}

  //changeCAAcceptedValue(event) {
  //  debugger;
  //  this.docAccessOutput.IsCAAccepted = event;
  //}

  getdocAccessDetails() {
    if (this.user != '' && this.user != null) {
      if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
        this.docAccessInput.PropertyId = this.property.Id;
        this.docAccessInput.UserId = this.user.Id;
        this.ndaDetails.Name = this.user.FirstName + " " + this.user.LastName;
        this.ndaDetails.Address = this.property.FullAddress;
        this._propertyService.getAccessRequestForDocuments(this.docAccessInput).subscribe(response => {
          if (response != null) {
            this.docAccessOutput = response;
            // alert(this.docAccessOutput.IsCAAccepted);
          }
        });
      }
    }
  }

  OMApprovalRequired = false;
  DDApprovalRequired = false;
  OpenAddUserSlider(template: TemplateRef<any>, classes: any) {
    this.IsAgreementRequired = (this.property.DDConfidentialityAgreement != null && this.property.DDConfidentialityAgreement || this.property.ConfidentialityAgreement != null && this.property.ConfidentialityAgreement)
                                ? this.property.DDConfidentialityAgreement : false;
    this.OMApprovalRequired = this.property.OfferMemoReqApproval ? this.property.OfferMemoReqApproval : false;
    this.DDApprovalRequired = this.property.DueDiligenceReqApproval ? this.property.DueDiligenceReqApproval : false;

    this.IsAgreementRequired = this.property.ConfidentialityAgreement ? this.property.ConfidentialityAgreement : false;
    this.modalUserRef = this.modalService.show(template, { class: classes });
  }

  getUserCount(propertyid) {
    var source = 'OM';
    this._propertyManagerService.getDueDiligenceAccessCount(propertyid, source).subscribe(response => {
      this.OMUserCount = response;
    });
  }

  previews(template: TemplateRef<any>, classes, document, documentId) {
    var propertyId = this.propertyId
    var userId = this.user.Id;
    var constData = {
      UtmId: this.utm_id,
      UtmSource: this.utm_source,
      UtmMedium: this.utm_medium,
      UtmCampaign: this.utm_campaign,
      UtmTerm: this.utm_term,
      UtmContent: this.utm_content,
      Propertyid: propertyId,
      UserId: userId,
      DocumentId: documentId
    };
    this._propertyManagerService.saveOMViewToAuditLog(constData).subscribe(response => { });
    this.docPreview = document;
    this.documentPreview = this.modalService.show(template, { class: classes });
  }

  modalRefOM: BsModalRef;
  openModalForShareOM(template: TemplateRef<any>, classes: any) {
    this.sharedOmProperties = [];
    this.sharedOmProperties.push(this.property.Id);
    if (this.sharedOmProperties.length == 0) {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 property.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      this.modalRefOM = this.modalService.show(template, { class: classes });
    }
  }
  removeProperty(propertyId: number) { }

}
